export default "/images/vendor/flag-icon-css/flags/4x3/pr.svg?7845ecd77b3b58e3c8a531c23905ef9c";